import React, { useState, useEffect } from "react";
import { toastSuccess, toastError } from "../../utils";
import { addStockService, getItems } from "../../services/services";
import Select from "react-select";

const AddStockModal = ({ product, allProducts = [], onClose, onUpdated }) => {
  const [selectedProduct, setSelectedProduct] = useState(product || null);
  const [products, setProducts] = useState(allProducts);
  const [quantity, setQuantity] = useState("");

  useEffect(() => {
    if (!allProducts?.length) {
      loadProducts();
    } else {
      setProducts(allProducts);
    }
  }, [allProducts]);

  const loadProducts = async () => {
    try {
      const res = await getItems({ all: true });

      setProducts(res?.data?.response?.products || []);
    } catch (err) {
      toastError("Failed to load products");
    }
  };

  const handleSubmit = async () => {
    if (!selectedProduct?._id) return toastError("Select a product");
    if (!quantity || Number(quantity) <= 0)
      return toastError("Enter valid quantity");

    try {
      await addStockService(selectedProduct._id, Number(quantity));

      toastSuccess("Stock updated successfully");

      onUpdated();
      onClose();
    } catch (err) {
      toastError(err?.response?.data?.message || "Failed to update stock");
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
      }}
    >
      <div
        className="modal-dialog modal-md modal-dialog-centered"
        style={{ zIndex: 10000 }}
      >
        <div className="modal-content">
          <div className="modal-header bg-custom text-white py-2">
            <h5 className="modal-title mb-0">Update Stock</h5>
            <div className="fs-3" onClick={onClose}>
              <i className="bi bi-x"></i>
            </div>
          </div>

          <div className="modal-body">
            {/* Product Select */}
            <div className="mb-3">
              <label className="form-label">Select Product *</label>

              <Select
                options={products.map((p) => ({
                  value: p._id,
                  label: `${p.name} (Current: ${p.totalRemainingQty ?? 0})`,
                  data: p,
                }))}
                value={
                  selectedProduct
                    ? {
                        value: selectedProduct._id,
                        label: `${selectedProduct.name} (Current: ${selectedProduct.totalRemainingQty ?? 0})`,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  setSelectedProduct(selectedOption?.data || null)
                }
                placeholder="Search Product..."
                isClearable
              />
            </div>

            {/* Quantity */}
            <div className="mb-3">
              <label className="form-label">Add Quantity *</label>
              <input
                type="number"
                className="form-control"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                placeholder="Enter quantity"
              />
            </div>

            {/* Buttons */}
            <div className="text-end">
              <button className="btn btn-custom me-2" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-custom" onClick={handleSubmit}>
                Update Stock
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStockModal;
